export default [
  {
    path: '/login',
    name: 'auth-login',
    component: () => import('@/views/pages/authentication/Login.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/register/:affiliateCode?',
    name: 'auth-register',
    component: () => import('@/views/pages/authentication/Register.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
    props: true,
  },
  {
    path: '/forgot-password',
    name: 'auth-forgot-password',
    component: () => import('@/views/pages/authentication/ForgotPassword.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  { path: '/', redirect: { name: 'dashboard' } },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/dashboard/Dashboard.vue'),
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('@/views/users/Show.vue'),
  },
  {
    path: '/services',
    name: 'services-index',
    component: () => import('@/views/services/Index.vue'),
    meta: {
      permission: {
        resource: 'services',
        action: 'read',
      },
    },
  },
  {
    path: '/accounts',
    name: 'accounts-index',
    component: () => import('@/views/accounts/Index.vue'),
  },
  {
    path: '/accounts/:id',
    name: 'accounts-show',
    component: () => import('@/views/accounts/Show.vue'),
    props: true,
  },
  {
    path: '/invoices',
    name: 'invoices-index',
    component: () => import('@/views/invoices/Index.vue'),
  },
  {
    path: '/invoices/create/:id',
    name: 'invoices-create',
    component: () => import('@/views/invoices/Create.vue'),
    props: true,
  },
  {
    path: '/invoices/:id',
    name: 'invoices-show',
    component: () => import('@/views/invoices/Show.vue'),
    props: true,
  },
  {
    path: '/payments',
    name: 'payments-index',
    component: () => import('@/views/payments/Index.vue'),
  },
  {
    path: '/payments/:id',
    name: 'payments-show',
    component: () => import('@/views/payments/Show.vue'),
    props: true,
  },
  {
    path: '/transactions',
    name: 'transactions-index',
    component: () => import('@/views/transactions/Index.vue'),
  },
  {
    path: '/transactions/callback',
    name: 'transactions-callback',
    component: () => import('@/views/transactions/Callback.vue'),
  },
  {
    path: '/bank-receipts',
    name: 'bank-receipts-index',
    component: () => import('@/views/bank-receipts/Index.vue'),
  },
  {
    path: '/affiliates',
    name: 'affiliates-index',
    component: () => import('@/views/affiliates/Index.vue'),
    meta: {
      permission: {
        resource: 'affiliates',
        action: 'read',
      },
    },
  },
  {
    path: '/affiliate-users',
    name: 'affiliate-users-index',
    component: () => import('@/views/affiliate-users/Index.vue'),
    meta: {
      permission: {
        resource: 'affiliates',
        action: 'read',
      },
    },
  },
  {
    path: '/checkouts',
    name: 'checkouts-index',
    component: () => import('@/views/checkouts/Index.vue'),
  },
  {
    path: '/messages',
    name: 'messages-index',
    component: () => import('@/views/messages/Index.vue'),
  },
  {
    path: '/message/send',
    name: 'send-quick',
    component: () => import('@/views/messages/SendQuick.vue'),
  },
  {
    path: '/tickets',
    name: 'tickets-index',
    component: () => import('@/views/tickets/Index.vue'),
    meta: {
      contentRenderer: 'sidebar-left',
      contentClass: 'chat-application',
    },
  },
  {
    path: '/faqs',
    name: 'faqs-index',
    component: () => import('@/views/faqs/Index.vue'),
  },
  {
    path: '/documents',
    name: 'documents',
    component: () => import('@/views/pages/Documents.vue'),
  },
  {
    path: '/groups',
    name: 'groups',
    component: () => import('@/views/groups/Index.vue'),
  },
  {
    path: '/contacts',
    name: 'contacts',
    component: () => import('@/views/contacts/Index.vue'),
  },
  {
    path: '/contacts/:id?',
    name: 'contacts-group',
    props: true,
    component: () => import('@/views/contacts/Index.vue'),
  },
  {
    path: '/contacts/import/:id?',
    name: 'contacts-import',
    props: true,
    component: () => import('@/views/contacts/Import.vue'),
  },
  {
    path: '/campaigns/create',
    name: 'campaigns-create',
    component: () => import('@/views/campaigns/Create.vue'),
  },
  {
    path: '/campaigns/:id/edit',
    props: true,
    name: 'campaigns-edit',
    component: () => import('@/views/campaigns/Create.vue'),
  },
  {
    path: '/campaigns',
    name: 'campaigns-list',
    component: () => import('@/views/campaigns/Index.vue'),
  },
  {
    path: '/campaigns/:id',
    name: 'campaigns-show',
    props: true,
    component: () => import('@/views/campaigns/Show.vue'),
  },
  {
    path: '/users',
    name: 'users-index',
    component: () => import('@/views/admin/users/Index.vue'),
    meta: {
      permission: {
        resource: 'users',
        action: 'read',
      },
    },
  },
  {
    path: '/users/:id',
    name: 'users-show',
    component: () => import('@/views/users/Show.vue'),
    props: true,
    meta: {
      permission: {
        resource: 'users',
        action: 'read',
      },
    },
  },
  {
    path: '/resellers',
    name: 'resellers-index',
    component: () => import('@/views/admin/resellers/Index.vue'),
    meta: {
      permission: {
        resource: 'roles',
        action: 'read',
      },
    },
  },
  {
    path: '/roles',
    name: 'roles-index',
    component: () => import('@/views/admin/roles/Index.vue'),
    meta: {
      permission: {
        resource: 'roles',
        action: 'read',
      },
    },
  },
  {
    path: '/panels',
    name: 'panels-index',
    component: () => import('@/views/admin/panels/Index.vue'),
    meta: {
      permission: {
        action: 'read',
        resource: 'panels',
      },

    },
  },
  {
    path: '/packages',
    name: 'packages-index',
    component: () => import('@/views/admin/packages/Index.vue'),
    meta: {
      permission: {
        action: 'read',
        resource: 'packages',
      },

    },
  },
  {
    path: '/products',
    name: 'products-index',
    component: () => import('@/views/admin/products/Index.vue'),
    meta: {
      permission: {
        action: 'read',
        resource: 'products',
      },

    },
  },
  {
    path: '/discount-codes',
    name: 'discount-codes-index',
    component: () => import('@/views/admin/discount-codes/Index.vue'),
    meta: {
      permission: {
        action: 'read',
        resource: 'discount.codes',
      },

    },
  },
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/error/Error404.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      action: 'read',
    },
  },
  {
    path: '/not-authorized',
    name: 'not-authorized',
    component: () => import('@/views/error/NotAuthorized.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      action: 'read',
    },
  },
]
